import React, { useEffect } from 'react';

import AuthThanksPage from './Auth';
import UnAuthThanksPage from './Unauth';

import { removeUserSessionData, scrollToTop } from 'common/utils/app.utils';

const ThanksPage = (props: any) => {
  const {
    userType,
    leadId,
    noNetwork,
    hideNetworkSteps,
    via,
    isMultiSite = false,
    isThankYouAuth = false,
    isAuthJourney
  } = props && props.location && props.location.state ? props.location.state : props;

  useEffect(() => {
    removeUserSessionData();
    scrollToTop();
  }, []);

  return (
    <React.Fragment>
      {isAuthJourney || isThankYouAuth ? (
        <AuthThanksPage userType={userType} leadId={leadId} noNetwork={noNetwork} hideNetworkSteps={hideNetworkSteps} via={via} isMultiSite={isMultiSite} />
      ) : (
        <UnAuthThanksPage userType={userType} leadId={leadId} noNetwork={noNetwork} hideNetworkSteps={hideNetworkSteps} via={via} isMultiSite={isMultiSite} />
      )}
    </React.Fragment>
  );
};

export default ThanksPage;
